import * as Const from '../constants/actionConstants';

import State from '../interfaces/states/SubFormOptionsState';

const initState: State = {
  availableProduct: [],
  availablePackage_: [],
  isLoading: false,
  isError: false,
};

export default function subFormOptions (state: State = initState, action): State {
  switch (action.type) {
    case Const.SUB_CHANGE_AVAILABLE_PRODUCT:
      return {
        ...state,
        availableProduct: action.availableProduct,
      };

    case Const.SUB_CHANGE_AVAILABLE_PACKAGE:
      return {
        ...state,
        availablePackage_: action.availablePackage_,
      };

    case Const.SUB_FORM_NOT_SEND:
      return {
        ...state,
        isLoading: false,
      };

    case Const.SUB_IS_LOADING_FORM:
      return {
        ...state,
        isLoading: action.isLoading,
      };

    default:
      return state;
  }
}
